import { ThemeOptions } from '@mui/material';

// Colors

const neutral = {
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
};

const background = {
    default: '#F4F6F8',
    paper: '#FFFFFF',
};

// const divider = '#E6E8F0';

const primary = {
    main: '#1875d1',
    contrastText: '#FFFFFF',
};

const secondary = {
    main: '#f50057',
    contrastText: '#FFFFFF',
};

// const success = {
//     main: '#4caf50',
//     contrastText: '#FFFFFF',
// };

const success = {
    main: '#8bc34a',
    contrastText: '#FFFFFF',
};

// const info = {
//     main: '#2196F3',
//     light: '#64B6F7',
//     dark: '#0B79D0',
//     contrastText: '#FFFFFF',
// };

// const warning = {
//     main: '#ff9800',
//     contrastText: '#FFFFFF',
// };

const error = {
    main: '#f44336',
    contrastText: '#FFFFFF',
};

// const text = {
//     primary: '#121828',
//     secondary: '#65748B',
//     disabled: 'rgba(55, 65, 81, 0.48)',
// };

export const lightThemeOptions: ThemeOptions = {
    components: {
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: neutral[100],
                    '.MuiTableCell-root': {
                        color: neutral[700],
                    },
                },
            },
        },
    },

    palette: { background, primary, secondary, success, error },
};
